/**
 * <ChampionSays> — un champion, et ce qu'il dit, dans sa bulle à côté de lui (molecule).
 *
 * L'ancienne bulle de champion de l'espace tuteur : Sam qui prépare un live, résume un élève ou ouvre
 * la prescription. Défaut Sam. Un champion qui s'adresse à la personne en pied, avec sa bulle, c'est
 * `<SpeechBubble>` à côté de `<ChampionFigure>` (`CLAUDE.md` § « Un champion qui parle »).
 *
 * Composes `<ChampionAvatar>` + `<Card>` + `<Text>`.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { ChampionAvatar, type ChampionName } from "../../atoms/Avatar/ChampionAvatar"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"

export type ChampionSaysProps = {
    /** Une phrase, ou un texte déjà composé. */
    message: React.ReactNode
    /** Défaut `sam`. */
    champion?: ChampionName
    testID?: string
}

export function ChampionSays(props: ChampionSaysProps) {
    const { message, champion = "sam", testID } = props
    return (
        <Row gap="3" align="start" testID={testID}>
            <ChampionAvatar name={champion} size={54} />
            <Card background="surface-subtle" elevation="none" p="3" style={styles.bubble}>
                {typeof message === "string" ? <Text color="text-primary">{message}</Text> : message}
            </Card>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    bubble: { flex: 1, flexShrink: 1 },
}))
